import React, { FC } from 'react';

const DefaultLoadingComponent: FC<any> = () => <div>LOADING ...</div>;

export default DefaultLoadingComponent;
